import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#5b64ee",
        secondary: "#9BABBD",
        tertiary: "#F1F3FF",
        accent: "#FF3553",
        error: "#F64E60",
        info: "#8950FC",
        success: "#1BC5BD",
        warning: "#FFA800",
        background: "#F2F5FA",
        surface: "#ffffff"
      },
      dark: {
        primary: "#a5aaf6",
        secondary: "#7c7c80",
        tertiary: "#494a4f",
        accent: "#FF3553",
        error: "#ec9099",
        info: "#d9d6fe",
        success: "#81bda1",
        warning: "#fbc278",
        background: "#222326",
        surface: "#2d2e32"
      }
    }
  },
  icons: {
    iconfont: "fa"
  }
});
